import $ from '../core/Dom';
import Viewport from '../core/Viewport';

export default (el, props) => {
    const $el = $(el);
    
    const activateLink = area => {
        const $link = $el.find('[data-mainarea-link="' + area + '"] span');
        
        if ($link.length > 0) {
            $link.addClass('-faux-hover');
        }
    };
    
    const deactivateLink = area => {
        const $link = $el.find('[data-mainarea-link="' + area + '"] span');
        
        if ($link.length > 0) {
            $link.removeClass('-faux-hover');
        }
    };
    
    
    const init = () => {

        $el.find('[data-mainarea-image]').on('mouseenter', e => {
            const $image = $(e.triggerTarget);
            const area = $image.data('mainarea-image');
            
            activateLink(area);
        });
        
        $el.find('[data-mainarea-image]').on('mouseleave', e => {
            const $image = $(e.triggerTarget);
            const area = $image.data('mainarea-image');
            
            deactivateLink(area);
        });
    };
    
    const destroy = () => {
    
    };

    return {
        init,
        destroy
    };
};
